import withConfigTransport from '../../../services/config-transport/withConfigTransport'
import VaTreeCategory from './VaTreeCategory.vue'

export default withConfigTransport(VaTreeCategory as any)
